"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullGameDownloadNotAvailableContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

var _StepController = require("../../molecules/StepController");

var _Modal = require("../../molecules/Modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var FullGameDownloadNotAvailableContent = function FullGameDownloadNotAvailableContent(_ref) {
  var _history$location, _history$location$pat;

  var history = _ref.history,
      pathToReplace = _ref.pathToReplace;
  return /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: "message"
  }, /*#__PURE__*/_react.default.createElement(_Modal.ContentSection, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "download-not-available-message",
    type: _atoms.Label.Type.Body,
    color: _atoms.Color.Black,
    content: "This full game download is not available. You can still download any individual moments."
  })), /*#__PURE__*/_react.default.createElement(_Modal.FooterSection, null, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Select Playlist Pressed",
    content: "Select another playlist",
    href: history === null || history === void 0 ? void 0 : (_history$location = history.location) === null || _history$location === void 0 ? void 0 : (_history$location$pat = _history$location.pathname) === null || _history$location$pat === void 0 ? void 0 : _history$location$pat.replace(pathToReplace, "choose"),
    primary: true
  })));
};

exports.FullGameDownloadNotAvailableContent = FullGameDownloadNotAvailableContent;